export const formElement = (target) => {
  const el = {
    formElement: target,
    formElementOther: target.classList.contains('form-element--other') && target,
    input: target.querySelector('input') || target.querySelector('select') || target.querySelector('textarea'),
    otherInput: target.querySelector('.form-element__other input'),
  }

  const method = {
    init: () => {
      method.checkIfFilled()

      el.input.addEventListener('keyup', () => {
        method.checkIfFilled()
        method.removeErrorMessage()
      })

      el.input.addEventListener('change', () => {
        method.checkIfFilled()
        method.removeErrorMessage()
      })

      if (el.input.type === 'password') {
        el.formElement
          .querySelector('.form-element__password-icon')
          .addEventListener('click', method.showHidePassword)
      }

      if ((el.input.type === 'checkbox' || el.input.type === 'radio') && el.formElementOther) {
        el.input.addEventListener('change', method.handleOtherInput)
      }
    },

    checkIfFilled: () => {
      if (el.input.value.length > 0) {
        el.formElement.classList.add('form-element--filled-in')
      } else {
        el.formElement.classList.remove('form-element--filled-in')

        if (el.formElement.classList.contains('form-element--password')) {
          el.input.setAttribute('type', 'password')
          el.formElement.classList.remove('form-element--password-visible')
        }
      }
    },

    handleOtherInput: () => {
      el.otherInput.focus()
    },

    removeErrorMessage: () => {
      if (el.formElement.classList.contains('form-element--with-error')) {
        el.formElement.classList.remove('form-element--with-error')
      }
    },

    showHidePassword: (event) => {
      el.input.setAttribute('type', el.input.type === 'password' ? 'text' : 'password')

      if (el.input.type !== 'password') {
        el.formElement.classList.add('form-element--password-visible')
      } else {
        el.formElement.classList.remove('form-element--password-visible')
      }

      event.preventDefault()
    },
  }

  method.init()
}
